import _ from 'underscore';
import * as PopupEditor from '@bingads-webui/popup-editor';
import { InlineEditableSave } from './save';

export function InlineEditableColumnPrompt({
  position, item, view, i18n, key,
}) {
  const schema = {
    key: 'Id',
    name: 'Keyword',
    parent: 'AdGroup',
    properties: {
      MatchType: {
        chooseType: 'checkbox',
        enum: ['Exact', 'Phrase', 'Broad'],
        filterable: true,
        isReadOnly: true,
        nullable: true,
        type: 'string',
        'bulk-upload-header': 'Match Type',
      },
    },
    type: 'object',
  };
  schema.properties.MatchType.enum = _.without(schema.properties.MatchType.enum, 'Content');

  const valueMessages = {};
  _.each(schema.properties.MatchType.enum, (value) => {
    valueMessages[value] = i18n.getString(`Details_View_Match_Type_${value}`);
  });

  const fields = [{
    property: 'MatchType',
    valueMessages,
  }];

  const matchTypeMap = {
    1: 'Exact',
    2: 'Phrase',
    3: 'Broad',
  };

  PopupEditor.prompt({
    position,
    i18n,
    schema,
    model: _.defaults({
      MatchType: matchTypeMap[item.Opportunities[0].NewMatchType]
        || matchTypeMap[item.Opportunities[0].MatchType],
    }, item),
    fields,
    hasLabels: false,
    template: 'inline',
    parentContainerSelector: '.grid-and-disclaim-container',
    saveModel: (updated, editorView) =>
      InlineEditableSave({
        view,
        updated,
        key,
        editorView,
      }),
  });
}
